import React from 'react';
import Link from 'next/link';

export default function SiteFooter() {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <h3 className="font-serif text-xl font-semibold mb-4 text-primary-foreground">
              Coed Parc
            </h3>
            <p className="font-sans text-sm leading-relaxed text-primary-foreground/70 mb-4">
              A Grade II listed house in Bridgend, Wales. Built in 1899. Under careful restoration.
            </p>
            <p className="font-sans text-xs text-primary-foreground/50 tracking-wide uppercase">
              Est. 1899 · Bridgend, Wales
            </p>
          </div>
          <div>
            <h4 className="font-sans text-xs font-semibold uppercase tracking-widest text-accent mb-5">
              Explore
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Home', href: '/' },
                { label: 'History', href: '/history-page' },
                { label: 'Restoration', href: '/#restoration' },
                { label: 'Community Stories', href: '/community-stories' },
                { label: 'The Future', href: '/#future' },
              ]?.map((link) => (
                <li key={`footer-${link?.label}`}>
                  <Link
                    href={link?.href}
                    className="font-sans text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-sans text-xs font-semibold uppercase tracking-widest text-accent mb-5">
              Contribute
            </h4>
            <ul className="flex flex-col gap-3">
              <li>
                <Link
                  href="/share-your-story"
                  className="font-sans text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                >
                  Share Your Story
                </Link>
              </li>
              <li>
                <Link
                  href="/#contact"
                  className="font-sans text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                >
                  Get In Touch
                </Link>
              </li>
              <li>
                <Link
                  href="/sign-up-login-screen"
                  className="font-sans text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                >
                  Create Account
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-primary-foreground/20 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-sans text-xs text-primary-foreground/50">
            © 2024 Coed Parc Restoration Project · Bridgend, Wales
          </p>
          <p className="font-sans text-xs text-primary-foreground/40 italic">
            Tŷ Coed Parc — preserving the past, building the future
          </p>
        </div>
      </div>
    </footer>
  );
}